<template>
  <div id="cardApp" class="app-wrapper">
    <div class="main-wrapper">
      <main class="content-main">
        <img src="@/assets/hktcmbanner.jpg" style="width:100%" />
        <img src="@/assets/hktcmbg.jpg" style="width:100%" />
        
        <div class="page-title-row" style="display: flex; justify-content: space-between; align-items: center;">
          <h3 style="margin: 0;">Credit Card Application</h3>
        </div>

        <div class="apply-section">
          <div class="apply-item">
            <div class="apply-info">
              <div class="apply-title">Existing Trust Client Application</div>
            </div>
            <a href="https://member.hongkongtrust.com.hk/#/login" class="apply-btn apply-btn-primary" style="text-decoration: none;">Apply Now</a>
          </div>
        </div>

        <!-- 新用户申请表单 -->
        <div class="new-user-form-section">
          <div class="form-header">
            <h3>New Trust Client Application</h3>
            <p>Please fill in your contact information below</p>
          </div>
          
          <form @submit.prevent="submitNewUserForm" class="new-user-form">
            <div class="form-group">
              <label class="form-label">
                <span class="required">*</span> Name
              </label>
              <input 
                type="text" 
                v-model="newUserForm.name" 
                class="form-input" 
                required 
                placeholder="Please enter your full name" 
              />
            </div>

            <div class="form-group">
              <label class="form-label">
                <span class="required">*</span> Phone
              </label>
              <input 
                type="tel" 
                v-model="newUserForm.phone" 
                class="form-input" 
                required 
                placeholder="Please enter your phone number" 
              />
            </div>
            
            <div class="form-group">
              <label class="form-label">
                <span class="required">*</span> Email
              </label>
              <input 
                type="email" 
                v-model="newUserForm.email" 
                class="form-input" 
                required 
                placeholder="Please enter your email address" 
              />
            </div>
            
            <div class="form-group">
              <label class="form-label">Message <span class="optional">(Optional)</span></label>
              <textarea 
                v-model="newUserForm.message" 
                class="form-textarea" 
                placeholder="Any additional information"
                rows="4"
              ></textarea>
            </div>
            
            <div class="form-actions">
              <button type="submit" class="btn-submit">
                <!-- <span class="btn-icon">📤</span> -->
                Submit
              </button>
            </div>
          </form>
          <!-- 在 form-footer 下方添加联系信息 -->
<div class="contact-section">
  <div class="contact-item">
    <span class="contact-icon">📞</span>
    <div class="contact-info">
      <div class="contact-label">Customer Service Hotline</div>
      <div class="contact-value">+852 2752 0313</div>
    </div>
  </div>
  <div class="contact-item">
    <span class="contact-icon">✉️</span>
    <div class="contact-info">
      <div class="contact-label">Email Support</div>
      <div class="contact-value">info@hongkongtrust.com.hk</div>
    </div>
  </div>
  <div class="contact-item">
    <span class="contact-icon">🕐</span>
    <div class="contact-info">
      <div class="contact-label">Service Hours</div>
      <div class="contact-value">Mon-Fri 9:00-18:00 HKT (Excluding Public Holidays)</div>
    </div>
  </div>
</div>
        </div>

        <div style="margin-top: 20px; padding: 15px; background: #f8f9fa; border-radius: 8px; font-size: 13px; color: #666;">
          Online applications are not processed immediately and should not be used for urgent submissions. For any inquiries, please contact us promptly via email.
        </div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreditCardStatic',
  data() {
    return {
      newUserForm: {
        name: '',
        phone: '',
        email: '',
        message: ''
      }
    }
  },
  methods: {
    // submitNewUserForm() {
    //   if (!this.newUserForm.name || !this.newUserForm.phone || !this.newUserForm.email) {
    //     this.$message.warning('Please fill in all required fields.')
    //     return
    //   }
      
    //   console.log('Submitting new user form:', this.newUserForm)
      
    //   this.$message.success('Thank you! Your application has been submitted successfully.')
      
    //   this.newUserForm = {
    //     name: '',
    //     phone: '',
    //     email: '',
    //     message: ''
    //   }
    // }
    
async submitNewUserForm() {
  if (!this.newUserForm.name || !this.newUserForm.phone || !this.newUserForm.email) {
    this.$message.warning('Please fill in all required fields.')
    return
  }
  
  try {
    const response = await fetch('https://htkcmvisa.giize.com/submit_application.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.newUserForm)
    });
    
    const result = await response.json();
    
    if (result.status === 1) {
      this.$message.success('Thank you! Your application has been submitted successfully.');
      this.newUserForm = { name: '', phone: '', email: '', message: '' };
    } else {
      this.$message.error(result.message || 'Submission failed');
    }
  } catch (error) {
    console.error('Submission error:', error);
    this.$message.error('Network error. Please try again later.');
  }
}
  }
}
</script>

<style>
:root {
  --bg-light: #f8f9fc;
  --primary-color: #1E3A8A;
  --primary-hover: #3B82F6;
  --accent-color: #F59E0B;
  --border-color: #cbd5e1;
  --border-color-dark: #94a3b8;
  --text-primary: #1E293B;
  --text-secondary: #64748B;
  --text-error: #EF4444;
  --text-success: #10b981;
  --bg-white: #fff;
  --bg-gray: #f8f9fa;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
}

body, html { 
  margin: 0; padding: 0; height: 100%; 
  font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; 
  background-color: var(--bg-light); 
  overflow: hidden; 
}

.app-wrapper { display: flex; height: 100vh; }
.main-wrapper { flex: 1; display: flex; flex-direction: column; overflow: hidden; position: relative; }
.content-main { flex: 1; padding: 25px; overflow-y: auto; }

.apply-section { 
  background: white; 
  border-radius: var(--radius-lg); 
  padding: 25px; 
  box-shadow: var(--shadow-md); 
  margin-top: 20px; 
  border: 1px solid var(--border-color);
}

.apply-item { 
  display: flex; 
  justify-content: space-between; 
  align-items: center; 
  padding: 20px 0; 
  border-bottom: 1px solid var(--border-color); 
}
.apply-item:last-child { border-bottom: none; }

.apply-info { flex: 1; text-align: left; }
.apply-title { font-weight: 600; font-size: 16px; color: var(--text-primary); margin-bottom: 5px; }
.apply-desc { font-size: 14px; color: var(--text-secondary); }

.apply-btn { 
  min-width: 140px; 
  padding: 12px 24px; 
  border-radius: var(--radius-md); 
  font-weight: 500; 
  cursor: pointer; 
  text-align: center; 
  transition: all 0.3s ease; 
  font-size: 14px;
}

.apply-btn-primary { 
  background-color: var(--primary-color); 
  color: white; 
  border: 2px solid var(--primary-color); 
}
.apply-btn-primary:hover { 
  background-color: var(--primary-hover); 
  border-color: var(--primary-hover);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.apply-btn-secondary { 
  background-color: white; 
  color: var(--primary-color); 
  border: 2px solid var(--primary-color); 
}
.apply-btn-secondary:hover { 
  background-color: #eff6ff;
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

/* ========== 新用户表单样式 ========== */
.new-user-form-section {
  background: white;
  border-radius: var(--radius-lg);
  padding: 40px;
  box-shadow: var(--shadow-md);
  margin-top: 20px;
  border: 2px solid var(--border-color);
}

.form-header {
  margin-bottom: 35px;
  text-align: left;
  padding-bottom: 20px;
  border-bottom: 3px solid var(--border-color);
}

.form-header h3 {
  margin: 0 0 8px 0;
  color: var(--primary-color);
  font-size: 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-header h3::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 30px;
  background: var(--accent-color);
  border-radius: 2px;
}

.form-header p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.6;
}

.new-user-form {
  max-width: 700px;
  margin: 0 auto;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  position: relative;
}

.form-label {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 4px;
  text-align: left;
}

.form-label .required {
  color: var(--text-error);
  font-size: 18px;
  line-height: 1;
}

.form-label .optional {
  color: var(--text-secondary);
  font-weight: 400;
  font-size: 13px;
}

.form-input, .form-textarea {
  padding: 14px 16px;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 15px;
  color: var(--text-primary);
  transition: all 0.3s ease;
  background-color: var(--bg-white);
  width: 100%;
  box-sizing: border-box;
}

.form-input::placeholder, .form-textarea::placeholder {
  color: #94a3b8;
}

.form-input:focus, .form-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(30, 58, 138, 0.1);
  transform: translateY(-1px);
}

.form-input:hover:not(:focus), .form-textarea:hover:not(:focus) {
  border-color: var(--border-color-dark);
}

.form-textarea {
  resize: vertical;
  min-height: 120px;
  font-family: inherit;
}

.form-actions {
  display: flex;
  justify-content: flex-start;
  margin-top: 35px;
  padding-top: 25px;
  border-top: 3px solid var(--border-color);
}

.btn-submit {
  padding: 15px 40px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 100%);
  color: white;
  border: 2px solid var(--primary-color);
  border-radius: var(--radius-md);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: var(--shadow-md);
  position: relative;
  overflow: hidden;
}

.btn-submit::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}

.btn-submit:hover::before {
  left: 100%;
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
  border-color: var(--primary-hover);
}

.btn-submit:active {
  transform: translateY(0);
}

.btn-icon {
  font-size: 18px;
}


/* ========== 联系信息区域 ========== */
.contact-section {
  margin-top: 30px;
  padding: 20px 25px;
  background: linear-gradient(135deg, #f8f9fc 0%, #eef2f7 100%);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}

.contact-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contact-label {
  font-size: 12px;
  color: var(--text-secondary);
  font-weight: 500;
}

.contact-value {
  font-size: 14px;
  color: var(--primary-color);
  font-weight: 600;
}

/* ========== 追加到原有 <style> 末尾 ========== */
/* 1. 统一输入框、文本域、预览表格及字符计数器使用宋体 */
input, 
textarea, 
.el-input__inner, 
.el-textarea__inner, 
.form-input, 
.char-counter, 
.preview-table td,
.preview-table th {
  font-family: "SimSun", "Songti SC", "STSong", serif !important;
  /* 可选：保持数字等宽对齐，适合金额/编号类字段 */
  font-variant-numeric: tabular-nums; 
}

/* 2. 若仅希望“纯数字字段”使用宋体，可改用类名控制（按需添加） */
.contact-value {
  font-family: "SimSun", "Songti SC", serif !important;
  font-variant-numeric: tabular-nums;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .contact-section {
    grid-template-columns: 1fr;
    padding: 15px;
  }
  
  .contact-item {
    padding: 10px 0;
    border-bottom: 1px dashed var(--border-color);
  }
  
  .contact-item:last-child {
    border-bottom: none;
  }
}



/* 响应式设计 */
@media (max-width: 768px) {
  .apply-item { 
    flex-direction: column; 
    align-items: flex-start; 
    gap: 15px; 
  }
  
  .new-user-form-section {
    padding: 25px;
  }
  
  .form-header h3 {
    font-size: 20px;
  }
  
  .btn-submit {
    width: 100%;
    justify-content: center;
  }
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.new-user-form-section {
  animation: fadeIn 0.5s ease;
}

.form-group {
  animation: fadeIn 0.4s ease;
}

.form-group:nth-child(1) { animation-delay: 0.05s; }
.form-group:nth-child(2) { animation-delay: 0.1s; }
.form-group:nth-child(3) { animation-delay: 0.15s; }
.form-group:nth-child(4) { animation-delay: 0.2s; }
</style>